import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=c52808ce&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52808ce')) {
      api.createRecord('c52808ce', component.options)
    } else {
      api.reload('c52808ce', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=c52808ce&", function () {
      api.rerender('c52808ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22nZ4mBGEQlD7/JS/comp/ImgFallback.vue"
export default component.exports